import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import DashboardNavigation from './dashboard/navigation-component';
import DashboardComponent from './dashboard/component';
import InboxComponent from './inbox/component';
import BookingComponent from './bookings/component';
import ManageListingComponent from './listing/manage-listing-component';
import CreateListingComponent from './listing/create-listing-component';
import EditListingComponent from './listing/edit-listing-component';
import AccountComponent from './account/component';
import ReportsComponent from './reports/component';

import { checkAuthorization } from '../global/actions';
import { getUserInfo, getMessagingAccessToken, getMessagingClient } from './actions'


const mapStateToProps = state => ({
  dashboard: state.Dashboard,
  global: state.Global
});

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fetchingUserInfo: false,
      fetchingMessagingToken: false,
      fetchingMessagingClient: false,
      width: window.innerWidth,
    }

    this.onUpdatePart = this.onUpdatePart.bind(this);
  }

  componentWillMount() {
    let { history, global, dispatch } = this.props;
    //User must be logged in
    if (!global.userId || !global.token) {
      history.push('/login');
    } else {
      dispatch(checkAuthorization());
      window.addEventListener('resize', this.handleWindowSizeChange);
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  onUpdatePart = (fetches) => {
    if (!this.props.dashboard.user && !this.state.fetchingUserInfo) {
      fetches.fetchingUserInfo = true;
      this.props.dispatch(getUserInfo(this.props.global.userId));
    } else if (this.props.dashboard.user && this.state.fetchingUserInfo) {
      fetches.fetchingUserInfo = false;
    }
    if (!this.props.dashboard.messagingToken && !this.state.fetchingMessagingToken) {
      fetches.fetchingMessagingToken = true;
      this.props.dispatch(getMessagingAccessToken());
    } else if (this.props.dashboard.messagingToken && this.state.fetchingMessagingToken) {
      fetches.fetchingMessagingToken = false;
    }
  }

  componentDidUpdate(oldProps) {
    let fetches = {}
    //If user has not successfully logged in auto-direct to dashboard
    if (!this.props.global.userId || !this.props.global.token) {
      this.props.history.push('/login');
    } else if (this.props.global.userId && this.props.global.token) {

      this.onUpdatePart(fetches);

      if (this.props.dashboard.messagingToken
        && this.props.dashboard.user
        && !this.state.fetchingMessagingClient) {
        this.props.dispatch(getMessagingClient());
        fetches.fetchingMessagingClient = true;
      }
      if (this.props.dashboard.user
        && this.props.dashboard.user.userType === 'admin') {
        this.props.history.push('/admin');
      }
    }
    if (Object.keys(fetches).length > 0) {
      this.setState(fetches);
    }
  }

  render() {
    let { width } = this.state;
    let isMobile = width <= 576;
    return (<div>
      <DashboardNavigation isMobile={isMobile} />
      <Route exact path="/dashboard" render={() => { return (<DashboardComponent isMobile={isMobile} />) }} />
      <Route exact path="/dashboard/account" render={() => { return (<AccountComponent isMobile={isMobile} />) }} />
      <Route path="/dashboard/inbox" render={() => { return (<InboxComponent isMobile={isMobile} />) }} />
      <Route path="/dashboard/bookings" render={() => { return (<BookingComponent isMobile={isMobile} />) }} />
      <Route exact path="/dashboard/manage-listings" render={() => { return (<ManageListingComponent isMobile={isMobile} />) }} />
      <Route path="/dashboard/listing/forms" render={() => { return (<CreateListingComponent isMobile={isMobile} />) }} />
      <Route path="/dashboard/listing/edit" render={() => { return (<EditListingComponent isMobile={isMobile} />) }} />
      <Route path="/dashboard/reports" render={() => { return (<ReportsComponent isMobile={isMobile} />) }} />
    </div>);

  }
}

export default withRouter(connect(mapStateToProps)(Dashboard));
